import { render } from "./StockReceive.vue?vue&type=template&id=1d4529fa&scoped=true"
import script from "./StockReceive.vue?vue&type=script&lang=js"
export * from "./StockReceive.vue?vue&type=script&lang=js"

import "./StockReceive.vue?vue&type=style&index=0&id=1d4529fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4529fa"]])

export default __exports__